var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inspector-button",attrs:{"type":"button","data-cy":"inspector-button"},on:{"click":_vm.toggleInspector}},[_c('inline-svg',{attrs:{"src":_vm.inspectorIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }